"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles) {
    return {
        root: styling_1.mergeStyles("listing-form", styles.root),
        editor: styling_1.mergeStyles("listing-form-editor", styles.editor),
        section: styling_1.mergeStyles("listing-form-section", styles.section),
        sectionTitle: styling_1.mergeStyles("listing-form-section-title", styles.sectionTitle),
        sectionBody: styling_1.mergeStyles("listing-form-section-body", styles.sectionBody),
        actions: styling_1.mergeStyles("app-listing-form-actions", styles.actions)
    };
});
exports.getClassNames = getClassNames;
